<div class="skeleton-list" aria-hidden="true">
  <div class="skeleton-card" *ngFor="let i of placeholders">
    <div class="skeleton-line skeleton-line--title"></div>
    <div class="skeleton-line"></div>
    <div class="skeleton-line skeleton-line--short"></div>
  </div>
</div>
